module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/digi/digi-result/digi-result.component.scss
// module id = ./src/app/digi/digi-result/digi-result.component.scss
// module chunks = main